import { Button } from '../../../../components/ui/button';
import { hasDuplicateNames, type UploadRow } from '../../lib/uploadRows';
import UploadPreviewRow from './UploadPreviewRow';

interface UploadPreviewListProps {
  disabled: boolean;
  onEditName: (clientId: string, value: string) => void;
  onRemoveRow: (clientId: string) => void;
  onApplyAllSuggestions: () => void;
  onRevertAll: () => void;
  rows: UploadRow[];
}

const UploadPreviewList = ({
  disabled,
  onEditName,
  onRemoveRow,
  onApplyAllSuggestions,
  onRevertAll,
  rows,
}: UploadPreviewListProps) => {
  const hasSuggestions = rows.some((r) => r.suggestedName !== null);
  const duplicateError = hasDuplicateNames(rows);

  return (
    <div className="flex flex-col gap-2">
      {hasSuggestions && (
        <div className="flex items-center gap-2">
          <Button disabled={disabled} onClick={onApplyAllSuggestions} size="sm" type="button" variant="outline">
            Aplicar sugerencias a todos
          </Button>
          <Button disabled={disabled} onClick={onRevertAll} size="sm" type="button" variant="ghost">
            Revertir todo
          </Button>
        </div>
      )}

      <div className="max-h-72 overflow-y-auto rounded-lg border border-border-subtle bg-bg-surface px-4">
        {rows.map((row) => (
          <UploadPreviewRow
            key={row.clientId}
            disabled={disabled}
            onEditName={onEditName}
            onRemove={onRemoveRow}
            row={row}
          />
        ))}
      </div>

      {duplicateError && (
        <p className="text-xs font-medium text-error">Hay nombres duplicados. Corrígelos antes de subir.</p>
      )}
    </div>
  );
};

export default UploadPreviewList;
